import convertToValidNumber from '@/components/global/Header/utils/convertToValidNumber';

interface CartUpdateDetail {
  count: number;
}

const isCartUpdateEvent = (event: Event): event is CustomEvent<CartUpdateDetail> => {
  if (typeof event !== 'object' || event === null) {
    return false;
  }

  const maybeCustom = event as CustomEvent<unknown>;
  const { detail } = maybeCustom;

  if (typeof detail !== 'object' || detail === null || !('count' in detail)) {
    return false;
  }

  return convertToValidNumber(detail.count) !== undefined;
};

export default isCartUpdateEvent;
